<template>
  <div class="send-feedback px30 pt-8">
    <button
      v-ripple
      type="button"
      class="btn-empty-wrapper mb-10"
      @click="clickHandler"
    >
      <Close icon="back" />
    </button>
    <h3 class="page-title font-bold text-28 text-text tracking-tight leading-tight mb-6">
      <span class="text-primary">{{ $t("Send") }}</span>
      <span class="text-secondary">{{ $t("Feedback") }}</span>
    </h3>
    <div
      class="form-items"
      :class="formEnabeled"
    >
      <FormulateForm #default="{ hasErrors }" v-model="values">
        <div v-for="item in schema" :key="item.name">
          <div v-if="item.name === 'document'" class="mb-10">
            <div class="upload-document" @click="uploadFile">
              <input
                :type="item.type"
                class="form-control"
                ref="file"
                multiple
                @change="uploadDocuments"
              />
            </div>
            <div 
              v-if="documents.length > 0" 
              class="list-document my-2">
              <div 
                v-for="(doc, index) in documents"
                :key="`doc-${index}`"
                class="mb-2">
                <div class="flex justify-between bg-text-primary rounded p-2">
                  <p class="text-white">
                    {{ doc.imageName }}
                  </p>
                  <p
                    type="button"
                    class="text-white"
                    @click="deleteSelectDocument(index)"
                  >
                    <Delete />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <FormulateInput v-else v-bind="item" :hasErrors="hasErrors" />
        </div>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
import Close from "../UI/Close";
import Delete from "../../components/Icons/DeleteIcon";

export default {
  name: "SendFeedback",
  components: {
    Close,
    Delete
  },

  props: ["clickHandler"],

  data: function() {
    return {
      avatar: "",
      documents: [],
      schema: [
        {
          type: "text",
          name: "name",
          placeholder: this.$t("Name"),
          validation: "required"
        },
        {
          type: "email",
          name: "email",
          placeholder: this.$t("Email"),
          validation: "required|email"
        },
        {
          type: "text",
          name: "subject",
          placeholder: this.$t("Subject"),
          validation: "required"
        },
        {
          type: "textarea",
          name: "message",
          placeholder: this.$t("Message"),
          validation: "required"
        },
        {
          type: "file",
          name: "document",
          placeholder: this.$t("Upload Image/Video")
        },
        {
          type: "customButton",
          label: this.$t("Submit"),
          formHandler: this.formHandler
        }
      ],
      values: {
        email: this.$user("email"),
        name: this.$user("name")
      }
    };
  },
  
  computed: {
    formEnabeled () {
      return {
        'form-enabled': this.values.name && this.values.email && this.values.subject && this.values.message
      }
    }
  },

  methods: {
    deleteSelectDocument: function(index) {
      this.documents.splice(index, 1);
      this.removeFileFromFileList(index)
    },
    removeFileFromFileList(index) {
      const dt = new DataTransfer()
      const input = this.$refs['file'][0]
      const { files } = input
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        if (index !== i)
          dt.items.add(file) // here you exclude the file. thus removing it.
      }
      input.files = dt.files // Assign the updates list
    },
    uploadFile () {
      this.$refs['file'][0].click()
    },
    uploadDocuments: function(e) {
      if (e.target.files.length > 0) {
        e.target.files.forEach((file, index) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            let image = {
              imageData: reader.result,
              imageName: file.name
            };
            this.documents.push(image);
          };
        });
      }
    },
    async formHandler() {
      if (this.documents.length) {
        this.values.documents = this.documents;
      }
      const response = await this.$http.post('user/send_feedback', this.values)
      if(!response.status) return
      this.$setState('setActiveSettings', null)
    }
  }
};
</script>